import { render, staticRenderFns } from "./ParticipantTable.vue?vue&type=template&id=95b68ed2&scoped=true&"
import script from "./ParticipantTable.vue?vue&type=script&lang=js&"
export * from "./ParticipantTable.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantTable.vue?vue&type=style&index=0&id=95b68ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b68ed2",
  null
  
)

export default component.exports